import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { LoginService } from "src/app/authuntication/auth-service/login.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  requestCount = 0;
  isRefreshing: boolean = true;
  isExpired: boolean = true;

  constructor(private _tokenService: LoginService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let header: any = {
      "x-api-version": environment.apiVersion
    };
    let token = this._tokenService.currentUser.value;
    if (token) {
      header['Authorization'] = `Bearer ${token}`;
    }
    request = request.clone({
      setHeaders: header
    });
    return next.handle(request).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status != 401) {
              return
            } else if (err.error.error === 'TOKEN_EXPIRED' && this.isExpired) {
              this.isExpired = false;
              let ref: any = localStorage.getItem('refresh_token');
              header['Authorization'] = `Bearer ${ref}`;
              request = request.clone({
                setHeaders: header
              });
              this._tokenService.currentUser.next(ref);
              return this._tokenService.RefreshToken().subscribe((res: any) => {
                if (this.isRefreshing) {
                  this._tokenService.currentUser.next(res.data.access_token);
                  localStorage.removeItem('userToken')
                  localStorage.setItem('userToken', res.data.access_token)
                   localStorage.getItem('userToken')
                  this.isRefreshing = false
                }
              },
                (err) => {
                  this._tokenService.logout()
                }
              );

            } else {
              return throwError(() => err);
            }
          } else {
            return
          }
        }
      })
    )
  }
}